import React, {useEffect, useMemo, useState} from "react";
import { CircularProgress } from "@mui/material";

import {
  getMatcehsDetailsByMatchId,
  getTournamentIdByTournamentName,
  getTournamentTypeById,
} from "../network/lib/APIs";
import ScoreCard from "../components/scoreCard";
import { useParams } from "react-router-dom";
import { io } from "socket.io-client";
import { MatchHeader } from "../components/header";
import {throttle} from "lodash";

// Custom hook to track window width
function useWindowWidth() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
}

function SingleMatch() {
  const [data, setData] = useState<any>([]);

  const { tournament_slug, matchuuid } = useParams();
  const [tournamentType, setTournamentType] = useState("");
  const [transformedLiveMatchdata, setTransformedLiveMatchdata] = useState<any>(
    []
  );
  const [isloading, setIsLoading] = useState(false);
  const [tournamentId, setTournamentID] = useState();

  const [liveScore, setLiveScore] = useState<any>([]);

  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [isConnected, setIsConnected] = useState(false);

  const windowWidth = useWindowWidth();

  const socket = io(
      process.env.REACT_APP_STAGE === "prod"
          ? "https://livefeed1.scorebuzzer.com"
          : "https://livefeed1-qa.scorebuzzer.com",
      {
        path: "/socket.io",
        transports: ["websocket"]
      }
  );// prod: https://livefeed.scorebuzzer.com

  const throttledSetLiveScore = useMemo(
      () => throttle(setLiveScore, 300),
      []
  );

  // let tournament_id = tournamentId;
  const tournament_name = tournament_slug;

  useEffect(() => {
    fetchTournamentIdByTournamentName();
  }, [tournament_name]);

  useEffect(() => {
    fetchAllMatcheByUUID();
  }, [matchuuid, tournamentType]);

  useEffect(() => {
    fetchTournamentTypeById();
  }, [tournamentId]);

  const fetchTournamentIdByTournamentName = async () => {
    try {
      if (!tournament_name) {
        throw new Error("Tournament name is undefined");
      }
      const response: any = await getTournamentIdByTournamentName(
        tournament_name
      );
      setTournamentID(response.data.tournamentId);
      // log the tournament id
    } catch (error) {
      console.error(error);
    }
    console.log("tournament id is:", tournamentId);
  };

  const fetchTournamentTypeById = async () => {
    try {
      if (tournamentId !== undefined) {
        const response: any = await getTournamentTypeById(tournamentId);
        setTournamentType(response.data.tournamentType);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllMatcheByUUID = async () => {
    try {
      const response = await getMatcehsDetailsByMatchId(
        matchuuid,
        tournamentType
      );
      console.log("API Response:", response.data);

      if (response.data) {
        const dataArray = Array.isArray(response.data)
          ? response.data
          : [response.data];
        console.log("dataArray", dataArray);
        setData(dataArray);
      } else {
        console.warn("No data found in API response");
        setData([]);
      }
    } catch (error) {
      console.error("GET MATCHES ERROR", error);
    }
  };

  const handleShareClick =
    (matchuuid: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      const tournamentUrl = `${window.location.href}/matches/${matchuuid}`;
      navigator.clipboard
        .writeText(tournamentUrl)
        .then(() => {
          console.log("URL copied to clipboard:", tournamentUrl);
          alert("Tournament URL copied to clipboard");
        })
        .catch((error) => {
          console.error("Failed to copy tournament URL: ", error);
        });
    };

  // console.log("responsedata", data);

  // // socket connection
  // useEffect(() => {
  //   // no-op if the socket is already connected
  //   if (socket && !socket.connected) {
  //     socket.connect();
  //   }
  //
  //   return () => {
  //     socket.disconnect();
  //   };
  // }, []);
  //
  // useEffect(() => {
  //   function onScoreUpdate(score: any) {
  //     console.log("updating score:", score.score);
  //     setLiveScore(score.score);
  //   }
  //   console.log("tournamentId" + ": " + tournamentId);
  //
  //   if (tournamentId) {
  //     //debug code
  //     console.log("did mount");
  //     console.log("socket details", socket);
  //
  //     //console.log('tournament_channel_19:App\\Events\\ScoreUpdate');
  //     // socket.on("connect", () => {
  //     //     console.log("socket connected", socket.connected); // true
  //     // });
  //
  //     socket.on("connect_error", (err: any) => {
  //       //socket.auth.token = "abcd";
  //       console.log(`connection error ${err.message}`);
  //       // some additional description, for example the status code of the initial HTTP response
  //       console.log(err.description);
  //
  //       // some additional context, for example the XMLHttpRequest object
  //       console.log(err.context);
  //     });
  //
  //     //https://testorg-qa.scorebuzzer.com/demo-tennis-tournament-2017
  //     //dynamic based on the tournament id
  //     const eventName = `tournament_channel_${tournamentId}:App\\Events\\ScoreUpdateNew` as string;
  //     socket.on(eventName, onScoreUpdate);
  //
  //     socket.on("disconnect", () => {
  //       console.warn("Socket disconnected");
  //     });
  //
  //     return () => {
  //       console.log("Cleaning up socket...");
  //       //socket.disconnect();
  //       socket.off(eventName, onScoreUpdate);
  //     };
  //   }
  // }, [tournamentId]);

  // Connection management
  useEffect(() => {
    const onConnect = () => setIsConnected(true);
    const onDisconnect = () => setIsConnected(false);

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
    };
  }, [socket]);

// Connect/disconnect based on tournamentId
  useEffect(() => {
    if (tournamentId) {
      socket.connect();
    }

    return () => {
      if (isConnected) {
        socket.disconnect();
      }
    };
  }, [tournamentId, socket, isConnected]);

// Score updates
  useEffect(() => {
    function onScoreUpdate(score: any) {
      try {
        console.log("updating score:", score.score);
        throttledSetLiveScore(score.score);
      } catch (error) {
        console.error("Error processing score update:", error);
      }
    }

    const onConnectError = (err: any) => {
      console.error(`Connection error: ${err.message}`);
    };

    if (tournamentId) {
      console.log("tournamentId detected");

      const eventName = `tournament_channel_${tournamentId}:App\\Events\\ScoreUpdateNew`;

      socket.on(eventName, onScoreUpdate);
      socket.on("connect_error", onConnectError);

      return () => {
        socket.off(eventName, onScoreUpdate);
        socket.off("connect_error", onConnectError);
      };
    }
    console.log("tournamentId, socket, throttledSetLiveScore update");
  }, [tournamentId, socket, throttledSetLiveScore]);



  useEffect(() => {
    try {
      const getStatusText = (status: any) => {
        switch (status) {
          case 1:
            return "Scheduled";
          case 4:
            return "Completed";
          case 5:
            return "Suspended";
          case 6:
            return "Retired";
          case 3:
            return "In Progress";
          case 10:
            return "Interrupted";
          default:
            return "Unknown";
        }
      };
      if (liveScore) {
        const transformedData = {
          matchId: liveScore?.matchId,
          status: getStatusText(liveScore?.status),
          score: {
            duration: liveScore?.duration,
            timeZone: liveScore?.timeZone,
            team1: {
              setsWon: liveScore?.team1?.score?.setsWon,
              sets:
                liveScore?.team1?.score?.sets?.map((set: any) => ({
                  setScore: set?.setScore ?? null,
                  tieBreakScore: set?.tieBreakScore ?? null,
                })) ?? [],
              gameScore: liveScore?.team1?.score?.gameScore,
              isCurrentServer: liveScore?.team1?.players[0]?.isServer || liveScore?.team1?.players[1]?.isServer,
              isWinner: false,
            },
            team2: {
              setsWon: liveScore?.team2?.score?.setsWon,
              sets:
                liveScore?.team2?.score?.sets?.map((set: any) => ({
                  setScore: set?.setScore ?? null,
                  tieBreakScore: set?.tieBreakScore ?? null,
                })) ?? [],
              gameScore: liveScore?.team2?.score?.gameScore,
              isCurrentServer: liveScore?.team2?.players[0]?.isServer || liveScore?.team2?.players[1]?.isServer,
              isWinner: false,
            },
            serveEvent:liveScore?.matchInfo,
            // serveEvent:
            //   liveScore?.serveEvent?.events
            //     ?.filter((event: any) => event?.event !== "firstserve")
            //     ?.map((event: any) => event?.event) ?? null,
          },
        };
        setTransformedLiveMatchdata(transformedData);
      }
    } catch (error) {
      console.log("useEffect error", error);
    }
  }, [liveScore]);

  return (
    <>
      <div
        className="flex flex-col md:flex-row mb-0 w-full"
        style={{ margin: 0, padding: 0 }}
      >
        <div className="w-full">
          <MatchHeader />
        </div>

      </div>

      {isloading ? (
        <div
          className="ml-1/2"
          style={{
            top: 200,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress color="primary" />
        </div>
      ) : (
        <div style={{ width: "100%" }}>
          {data?.map((item: any, index: number) => (
            <div
              className="grid grid-rows-auto md:grid-flow-cols m-4 md:m-24"
              key={index}
            >
              {item.cmatches?.map((cmatches: any) => {
                // Update match data if it matches the transformed live match data
                if (cmatches.matchId === transformedLiveMatchdata.matchId) {
                  cmatches.score = transformedLiveMatchdata.score;
                  cmatches.status = transformedLiveMatchdata.status;
                }

                // Prefix match description with court name for team events
                const courtName = cmatches.court;
                const prefixedDescription = courtName && cmatches.matchDescription
                  ? `${courtName} - ${cmatches.matchDescription} `
                  : cmatches.matchDescription
                    ? cmatches.matchDescription + " "
                    : undefined;

                return (
                    <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <div
                      className="w-full md:w-auto"
                      style={{
                        transform: windowWidth < 768 ? "scale(1)" : "scale(1.4)",
                        width: windowWidth < 768 ? "100%" : "600px",
                        maxWidth: "100%"
                      }}
                    >
                      <ScoreCard
                        key={cmatches.matchId}
                        matchId={cmatches.matchId}
                        matchDescription={prefixedDescription}
                        matchTypeName={
                          cmatches.matchTypeName !== null
                            ? cmatches.matchTypeName
                            : undefined
                        }
                        status={cmatches.status || undefined}
                        players={cmatches.players || undefined}
                        score={cmatches.score || undefined}
                        handleShare={handleShareClick(cmatches.matchuuid)}
                        isAlertOpen={isAlertOpen}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default SingleMatch;
